import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Ashley M.",
    location: "Dallas, TX",
    text: "The cookies were the hit of our Halloween party! The Bag of Boos is adorable and tasted even better than it looked. Will definitely order again.",
  },
  {
    name: "Caroline B.",
    location: "Aubrey, TX",
    text: "I've ordered for three baby showers now. Every set is beautifully iced and arrives on time — Sweet Rose is my go-to for any celebration.",
  },
  {
    name: "Jordan R.",
    location: "Frisco, TX",
    text: "We did the gift trios for our teachers and everyone raved. Such a sweet, thoughtful gift from a real small-batch baker.",
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive((a) => (a + 1) % REVIEWS.length), 7000);
    return () => clearInterval(t);
  }, []);

  const r = REVIEWS[active];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-[#F7EBEB]"
    >
      <div className="max-w-4xl mx-auto text-center">
        <div className="text-xs uppercase tracking-[0.22em] text-[#B37C7C] font-medium mb-6">
          Kind Words
        </div>
        <div className="flex items-center justify-center gap-1 mb-10">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={18} className="fill-[#B37C7C] text-[#B37C7C]" />
          ))}
          <span className="ml-3 text-sm text-[#5C5252]">5.0 on Google</span>
        </div>

        <Quote className="mx-auto text-[#B37C7C]/40 mb-6" size={36} />

        <blockquote
          key={active}
          className="fade-up font-serif-display text-2xl md:text-4xl text-[#362C2C] leading-[1.25] italic mb-10"
          data-testid="testimonial-quote"
        >
          "{r.text}"
        </blockquote>

        <div className="text-sm text-[#5C5252]">
          <div className="font-medium text-[#362C2C]">{r.name}</div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#B37C7C] mt-1">
            {r.location}
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 mt-10">
          {REVIEWS.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === active ? "w-8 bg-[#B37C7C]" : "w-2 bg-[#B37C7C]/30"
              }`}
              data-testid={`testimonial-dot-${i}`}
              aria-label={`Show review ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
